import { Box } from "@mui/material";
import { EntityType } from "@common/Common.types";
import MoreItemsBadge from "@common/components/moreItemsBadge/MoreItemsBadge";
import RiskAreaRiskLines from "./RiskAreaRiskLines";
import { RiskAreaHighestRisk } from "./RiskAreaRisks.types";

export interface IRiskAreaHighestRiskLine {
    riskAreas: Array<RiskAreaHighestRisk>;
    entityType: EntityType;
    entityId: string;
}

// The overview table cell for an entity's risk areas. One line per area made rows with several areas far taller
// than the rest, so only the worst area is shown (the backend orders them worst-first) and the others sit behind a
// "+N" whose tooltip lists every area.
function RiskAreaHighestRiskLine({ riskAreas, entityType, entityId }: IRiskAreaHighestRiskLine) {
    const [highestRiskArea, ...otherRiskAreas] = riskAreas;

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
            <Box sx={{ minWidth: 0 }}>
                <RiskAreaRiskLines riskAreas={[highestRiskArea]} entityType={entityType} entityId={entityId} />
            </Box>
            {otherRiskAreas.length > 0 && (
                <MoreItemsBadge
                    count={otherRiskAreas.length}
                    tooltip={<RiskAreaRiskLines riskAreas={riskAreas} entityType={entityType} entityId={entityId} rowGap={1} />}
                />
            )}
        </Box>
    );
}

export default RiskAreaHighestRiskLine;
